import { ThemeUICSSObject, spacing } from '@apia/theme';
import fields from './fields';
import container from './container';
import editGrid from './editGrid';
import fieldLabelWrapper from './fieldLabelWrapper';
/* IMPORT HERE */

const form: ThemeUICSSObject = {
  fields,
  container,
  editGrid,
  fieldLabelWrapper,
  /* PREPEND HERE */
  bg: 'form.backgroundColor',
  p: spacing(5),

  '.fieldWrapper': {
    flexDirection: 'column',

    '&:not(.check)': {
      justifyContent: 'start',
    },

    '&.check spacer': {
      display: 'none',
    },

    '&.check label': {
      alignItems: 'center',
      alignSelf: 'center',
      display: 'flex',
      height: '100%',
    },

    '.checkbox__field': {
      '& > .checkbox': {
        flexShrink: 0,
      },
    },

    '.checkbox__field, .checkbox__field span, .executionForm__radio, .executionForm__radio span':
      {
        fontWeight: 'normal',
      },

    '&.tree > .tree': {
      overflow: 'auto',
      flexGrow: 10,

      '& > .tree': {
        overflow: 'visible',
      },
    },
  },

  '.wrapper_TSK_SCHEDULER': {
    gridRowStart: 1,
  },
};

export default form;
